export default "__VITE_ASSET__c883cb1f__"